import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-attachment-item',
  templateUrl: './attachment-item.component.html',
  styleUrls: ['./attachment-item.component.scss'],
})
export class AttachmentItemComponent {
  @Input() allowChanges: boolean;
  @Input() attachment: any;
  @Input() type: string;
  @Input() source: string;
  @Output() show: EventEmitter<number> = new EventEmitter<number>();
  @Output() delete: EventEmitter<number> = new EventEmitter<number>();

  showImage(url) {
    this.show.emit(url);
  }

  deleteAsset(id) {
    this.delete.emit(id);
  }

  getAttachmentName() {
    if (this.type !== 'document') return ''

    return this.attachment?.name ?? this.attachment?.media?.name
  }

  canDeleteMedia() {
    const canChange = this.allowChanges && ['models', 'tools'].includes(this.source)
    const hasModelParentType = this.attachment?.parentType === 'tool_models'
    return hasModelParentType ? this.source === 'models' && canChange : canChange
  }
}
